import axios from "axios";
import { apiVariable } from "./apiVariable";

export const handleViewFile = async (
  row: any,
  type: string,
  token: string | null | undefined,
  unitNumber?: string | null
) => {
  const extensions = ["pdf", "jpg", "jpeg", "png"];
  for (const extension of extensions) {
    try {
      const url = `${apiVariable}/download/${row.id}/${type}/${extension}`;
      const response = await axios.get(url, {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
        ...(type === "personalFolder"
          ? {
              params: {
                fileName: `${row.fileName}`,
                employeeName: `${row.firstName + " " + row.lastName}`,
              },
            }
          : type === "assetFolder"
          ? {
              params: {
                fileName: `${row.fileName}`,
                unitNumber: `${unitNumber}`,
              },
            }
          : null),
      });

      if (response.status === 200) {
        const fileURL = window.URL.createObjectURL(response.data);
        window.open(fileURL, "_blank");
        return;
      }
    } catch (error: any) {
      if (!(error.response && error.response.status === 500)) {
        console.error("View error:", error);
        alert("An error occurred while opening the file.");
        return;
      }
    }
  }
  alert("No file found for the given ID and type.");
};
